<script setup>
import MembershipWeb from '@/components/guinness/guinness.vue'
// import MembershipMobile from '@/components/guinness/guinness-mobile.vue'
</script>
<template>
  <!-- /* 判读是从哪个入口进入 */ -->
  <MembershipWeb />
  <!-- <MembershipWeb v-else /> -->
</template>
<style lang="scss" scoped></style>
